import { MarketplaceDomainPayload } from './agentsSkillsTypes'

export type Option = { value: string; label: string; [key: string]: any }

export const ROW_HEIGHT = 48

export const TABS = {
  agents: 'agents',
  skills: 'skills',
  domains: 'domains'
}

export const SECTIONS = { details: 'details', specifications: 'specifications', media: 'media' }

export const MAX_CAPABILITIES = 10

export const MAX_ARC_ROLES = 10

export const ALLOWED_MEDIA_TYPES = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
  'image/svg+xml',
  'video/mp4',
  'video/webm'
]

export const ALLOWED_MEDIA_TYPES_LABEL = 'PNG, JPEG, GIF, WEBP, SVG, MP4, WEBM'

export const ALLOWED_SKILL_PACKAGE_EXTENSION = '.zip'

export const AGENT_PROVIDER_OPTIONS: Option[] = [
  { value: 'Centrali', label: 'Centrali' },
  { value: 'Snowflake', label: 'Snowflake' },
  { value: 'Copilot', label: 'Copilot' }
]

export const SKILL_PROVIDER_OPTIONS: Option[] = [
  { value: 'Centrali', label: 'Centrali' },
  { value: 'External', label: 'External' }
]

export const AVAILABILITY_LABEL_OPTIONS: Option[] = [
  { value: 'Live', label: 'Live' },
  { value: 'Beta', label: 'Beta' },
  { value: 'Coming Soon', label: 'Coming Soon' }
]

export const AVAILABILITY_LABEL_COLORS: Record<string, string> = {
  Live: 'success',
  Beta: 'info',
  'Coming Soon': 'secondary'
}

export const AVAILABILITY_BADGE_CLASS = '!text-sm !leading-none'

const stripSpaces = (value: string) => value.replace(/\s+/g, '').toLowerCase()

// The backend persists/returns some labels without spaces (e.g. "ComingSoon"), so lookups here
// are done on a space-stripped basis rather than requiring an exact string match.
const findAvailabilityLabelMatch = (value?: string | null): Option | null =>
  (value &&
    AVAILABILITY_LABEL_OPTIONS.find(
      (option) => stripSpaces(option.value) === stripSpaces(value)
    )) ||
  null

export const findAvailabilityLabelOption = (value?: string | null): Option | null =>
  findAvailabilityLabelMatch(value)

// Presentation-only helper: re-inserts the label's proper spacing for display.
export const formatAvailabilityLabel = (value?: string | null): string => {
  if (!value) return ''
  const match = findAvailabilityLabelMatch(value)
  return match ? match.label : value.replace(/([a-z])([A-Z])/g, '$1 $2')
}

export const serializeAvailabilityLabel = (value?: string | null): string | undefined => {
  if (!value) return undefined
  return value.replace(/\s+/g, '')
}

export const getAvailabilityLabelColor = (value?: string | null): string => {
  const match = findAvailabilityLabelMatch(value)
  return (match && AVAILABILITY_LABEL_COLORS[match.value]) || 'primary'
}

export const getAvailabilityBadgeProps = (value?: string | null) => {
  if (!value) return null

  return {
    color: getAvailabilityLabelColor(value),
    label: formatAvailabilityLabel(value),
    type: 'pill' as const,
    variant: 'light' as const,
    className: AVAILABILITY_BADGE_CLASS
  }
}

export const emptyForm: MarketplaceDomainPayload = {
  label: '',
  isActive: true
}
